import { render, staticRenderFns } from "./UiBadge.vue?vue&type=template&id=d246dcb6&scoped=true"
import script from "./UiBadge.vue?vue&type=script&lang=js"
export * from "./UiBadge.vue?vue&type=script&lang=js"
import style0 from "./UiBadge.vue?vue&type=style&index=0&id=d246dcb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d246dcb6",
  null
  
)

export default component.exports